<!--全局变量-->
<script>
import { getuserinfo, getVipByPackageId } from "./assets/js/api/exam_api";
const apiHost = window.__nb_api_host || "https://exam-app.nobook.com";
const passportApi = window.__nb_passport_api || "https://passport.nobook.com";
let passportPath = "nobook.com";
if (passportApi === "https://passport.noteach.com.cn") {
  passportPath = "noteach.com.cn";
}
let data = {
  // name: 'app',
  productId: 14, //套餐id 物理13 化学14
  pid: 26, //学科id 物理24 化学26
  subjectId: 2, //1是物理 2是化学
  userLoginInfo: {}, //用户登录信息
  userInfo: {}, // 用户信息
  request: {
    getVip: "",
    getInfo: "",
    toTime: "",
  }, //方法
  userVip: {},
  url: {
    pact: "https", //线上 https
    path: passportPath, //线上 com
    apiPath: `${apiHost}/api`, //线上 com
  },
  nowClass: "",
};

//获取用户信息.
let getInfo = () => {};

let getVip = () => {
  getVipByPackageId({ packageId: data.productId }).then((res) => {
    if (res.code == 200) {
      data.userVip = res.data;
    }
  });
};
//时间戳转为日期格式
data.request.toTime = function (timestamp, $type) {
  if (timestamp) {
    let date = new Date(timestamp);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate();
    let h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    let m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    let s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    let _time = "";
    //根据$type的值返回不同的时间格式
    switch ($type) {
      case 1:
        _time = Y + M + D + "  " + h + m + s;
        break;
      case 2:
        _time = Y + M + D;
        break;
      case 3:
        _time = h + m + s;
        break;
    }
    return _time;
  } else {
    return timestamp;
  }
};
//获取用户信息
data.request.getVip = getVip;
data.request.getInfo = getInfo;
export default data;
</script>



// WEBPACK FOOTER //
// src/global.vue